import { Injectable, OnDestroy } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NotificationService implements OnDestroy {
  private unsubscribe$ = new Subject<void>();
  private notificationSubject = new Subject<any>();

  constructor(private angularFireMessaging: AngularFireMessaging) {
    this.initFCMListener();
  }

  private initFCMListener() {
    this.angularFireMessaging.messages
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((payload: any) => {
        
        if (payload) {
          this.handleNotification(payload);
        }
      });
  }

  private handleNotification(payload: any) {
    payload.data.misc = (typeof payload.data.misc === 'string' && payload.data.misc != '') 
      ? JSON.parse(payload.data.misc) 
      : payload.data.misc;

    // Dispatch notification based on type
    this.notificationSubject.next(payload);
  }

  getNotificationByType(type: string) {
    return this.notificationSubject.asObservable()
      .pipe(filter((payload: any) => payload?.data?.type === type));
  }

  getAllNotifications() {
    console.log('gone');
    
    return this.notificationSubject.asObservable();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
